import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject, input } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Router } from "@angular/router";
import { filter } from "rxjs";
import { AuthService, INNOVEX_SAML_PROVIDER_ID } from "../services/auth.service";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { CommonModule } from "@angular/common";
import { LinkMicrosoftButtonComponent } from "../link-microsoft-button/link-microsoft-button.component";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
  imports: [CommonModule, MatButtonModule, MatCardModule, LinkMicrosoftButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  readonly auth = inject(AuthService);
  readonly #router = inject(Router);
  readonly #destroyRef = inject(DestroyRef);
  readonly type = input<string | null>(null);
  // Set by AuthGuard when a signed-out user opens a deep link.
  readonly returnUrl = input<string | null>(null);
  readonly innovexProviderId = INNOVEX_SAML_PROVIDER_ID;

  ngOnInit(): void {
    const type = this.type();
    if (type && type === INNOVEX_SAML_PROVIDER_ID && !this.auth.currentUser) {
      void this.auth.signIn(type);
    }

    const returnUrl = this.returnUrl();
    // Only in-app paths; "//host" would be an open redirect.
    if (returnUrl?.startsWith("/") && !returnUrl.startsWith("//")) {
      this.auth.isLoggedIn
        .pipe(filter(Boolean), takeUntilDestroyed(this.#destroyRef))
        .subscribe(() => void this.#router.navigateByUrl(returnUrl));
    }
  }
}
